<ng-container *ngIf="isLoaded && isActive">
  <div class="notice-banner-container" *ngIf="updatePaymentMessage"
    [class.success]="updatePaymentMessage?.type === 'SUCCESS'" [class.error]="updatePaymentMessage?.type === 'ERROR'">
    <div class="notice-banner">
      <div class="banner-text">
        <div class="d-flex flex-row">
          <div *ngIf="updatePaymentMessage?.type === 'ERROR'">
            <mat-icon [svgIcon]="'error-warning'"></mat-icon>
          </div>
          <div *ngIf="updatePaymentMessage?.type === 'SUCCESS'">
            <mat-icon [svgIcon]="'success'"></mat-icon>
          </div>
          <div class="d-flex flex-column ml-16">
            <div class="bold-text pb-2">{{updatePaymentMessage.title}}</div>
            <div class="description"> {{updatePaymentMessage.message}}</div>
          </div>
          <div class="banner-icon">
            <mat-icon (click)="onCloseMessageClicked()" [svgIcon]="'x-close-1'"></mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="header-title-container">
      <p><adp-label labelKey="Account_Billing_Payment_Heading"></adp-label></p>
    </div>
    <div class="mt-20 mb-20 max-width-82">
      <div class="mt-20 pb-4 header-desc">
        <adp-label labelKey="Account_Billing_Payment_Description"></adp-label>
      </div>
    </div>
  </div>
  <div class="container mt-15">
    <mat-tab-group (selectedTabChange)="this.onTabChange($event)" class="payment-tabs mt-20">
      <mat-tab label="{{tabData?.paymentBillingTabLabel}}">
        <ng-container *ngIf="selectedContract">
          <pgh-billing-info [(updatePaymentMessage)]="updatePaymentMessage" [user]="user"
            [selectedContract]="selectedContract">
          </pgh-billing-info>
        </ng-container>
      </mat-tab>
      <mat-tab label="{{tabData?.paymentHistoryTabLabel}}">
        <adp-setting key="Payment_History_Page_Size"></adp-setting>
        <app-payment-history></app-payment-history>
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-container>
